export default __webpack_public_path__ + "static/media/task.de621c68.svg";